import React from "react";
import { process, benefits } from "../mock";
import Reveal from "./Reveal";

export default function Process() {
  return (
    <section className="relative border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="mb-4 text-center text-[13px] font-medium uppercase tracking-[0.2em] text-violet-400">
            {process.eyebrow}
          </p>
          <h2 className="mx-auto max-w-2xl text-center font-display text-[30px] font-bold leading-tight text-white sm:text-[38px]">
            {process.heading}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {process.steps.map((step, i) => (
            <Reveal key={i} delay={i * 90}>
              <div className="surface-card relative h-full rounded-2xl p-7">
                <div className="font-display text-[52px] font-extrabold leading-none text-white/[0.08]">
                  {step.num}
                </div>
                <p className="mt-2 text-[12px] font-medium uppercase tracking-[0.18em] text-violet-400">
                  Paso {step.num}
                </p>
                <h3 className="mt-3 font-display text-[21px] font-semibold text-white">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-white/55">
                  {step.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Stats band */}
        <div className="mt-16 grid grid-cols-2 gap-6 rounded-3xl border border-white/[0.07] bg-white/[0.02] px-6 py-10 lg:grid-cols-3">
          {benefits.stats.map((s, i) => (
            <Reveal key={i} delay={i * 70}>
              <div className="text-center">
                <div className="text-gradient-violet font-display text-[34px] font-extrabold sm:text-[42px]">
                  {s.value}
                </div>
                <div className="mt-1.5 text-[13px] text-white/50">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
